import {
  FC,
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { AppLoader } from "../../../components/loading/LoadingOverlay";
import { DatePicker, IconButton, Loader } from "rsuite";
import { formatDate } from "../../../../util/date";
import { FaIcon } from "../../../components/fontawesome/icon";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { toRelativeCalendar } from "../../../../lib/date";
import { UserSupervision } from "../../../../domain/supervision/Supervision";
import { useByRequestSupervisionGroupViewModel } from "../../../../viewmodel/supervision-unity-group/ByRequestSupervisionGroup";
import { ByRequestSupervisionUnityModal } from "./component/modal";
import { SupervisionUnityGroupByRequestData } from "./component/data";
import { useNavigate } from "react-router-dom";
import { DashboardHeaderContext } from "../../../../hook/header";
import { useQueryNavigate } from "../../../../hook/navigate";
import { useQuery } from "../../../../hook/query";
import { DateTime } from "luxon";
import { toInteger } from "lodash";

export const ByRequestSupervisionUnityGroup: FC<any> = () => {
  const queryTimestamp = useQuery().get("timestamp");
  const initialSelectedTime = queryTimestamp
    ? DateTime.fromMillis(toInteger(queryTimestamp)).toJSDate()
    : new Date();
  const [selectedTime, setSelectedTime] = useState(initialSelectedTime);
  const navigate = useNavigate();
  const {
    fetchState,
    fetchUserSupervisionList,
    onFetchStateReceived,
    userSupervisionList,
    userSupervisionTimestamp,
    refreshEvent,
    requestRefreshEvent,
    onRefreshEventCompleted,
    onSelectItemCompleted,
    requestSelectItem,
    selectedItem,
  } = useByRequestSupervisionGroupViewModel();
  const loading = fetchState?.loading || undefined;
  const dashboardHeaderContext = useContext(DashboardHeaderContext);
  const queryNavigate = useQueryNavigate();
  /* eslint-disable */
  useEffect(() => {
    void fetchUserSupervisionList(selectedTime.getTime());
  }, [selectedTime]);

  useEffect(() => {
    if (fetchState && !fetchState.isLoading()) {
      if (fetchState.isFailed()) {
        window.toast.error(
          "Ocurrió un error al obtener la lista de rondas del usuario."
        );
        console.log(fetchState?.error);
      }
      onFetchStateReceived();
    }
  }, [fetchState]);

  useEffect(() => {
    if (refreshEvent) {
      void fetchUserSupervisionList(selectedTime.getTime(), true);
      onRefreshEventCompleted();
    }
  }, [refreshEvent]);

  const onTableItemSelected = useCallback((supervision: UserSupervision) => {
    navigate(
      `/dashboard/supervision?reference=${encodeURIComponent(
        supervision.reference
      )}`
    );
  }, []);

  const onTablePreviewActionClicked = useCallback(
    (supervision: UserSupervision) => {
      requestSelectItem(supervision);
    },
    []
  );

  useEffect(() => {
    dashboardHeaderContext.setTheme({
      className: "bg-secondary-header",
      title: "Rondas",
      dark: true,
      subtitle: "Seleccionar por fecha",
    });
  }, []);

  /* eslint-enable */
  return (
    <div className={"w-full"}>
      <AppLoader isActive={loading} />
      {!!selectedItem ? (
        <ByRequestSupervisionUnityModal
          supervision={selectedItem}
          onClose={onSelectItemCompleted}
        />
      ) : null}
      <div
        className={
          "flex-none w-full flex flex-row flex-wrap gap-2 p-2 border-b-2 border-neutral-100 overflow-x-hidden items-center justify-between"
        }
      >
        <span className={"text-lg font-normal text-neutral-600 uppercase"}>
          {formatDate(selectedTime)}
        </span>
        <div className={"flex flex-row flex-wrap items-center gap-2"}>
          <div className={"flex flex-row flex-wrap gap-2 items-center z-0"}>
            <span>Seleccionar fecha</span>
            <DatePicker
              size={"sm"}
              //appearance={"subtle"}
              value={selectedTime}
              onChange={(newDate) => {
                if (
                  !!newDate &&
                  newDate?.getTime() !== selectedTime.getTime()
                ) {
                  setSelectedTime(newDate);
                  queryNavigate({
                    timestamp: newDate.getTime(),
                  });
                }
              }}
            />
          </div>
          <IconButton
            size={"sm"}
            appearance={"primary"}
            onClick={requestRefreshEvent}
            icon={<FaIcon icon={faRefresh} />}
          >
            Actualizar
          </IconButton>
        </div>
      </div>
      {fetchState?.isLoading() ? (
        <Loader center backdrop size={"sm"} content={"Cargando..."} />
      ) : (
        <Fragment>
          {userSupervisionTimestamp ? (
            <div className={"w-full flex-none p-2"}>
              <p>
                <span className={"text-neutral-400 uppercase"}>
                  Última actualización:{" "}
                </span>
                {toRelativeCalendar(userSupervisionTimestamp.timestamp, true)}
              </p>
            </div>
          ) : null}
          <SupervisionUnityGroupByRequestData
            items={userSupervisionList}
            onPreview={onTablePreviewActionClicked}
            onClick={onTableItemSelected}
          />
        </Fragment>
      )}
    </div>
  );
};
